import { render, staticRenderFns } from "./m_storyofchina.vue?vue&type=template&id=50b75737&scoped=true"
import script from "./m_storyofchina.vue?vue&type=script&lang=js"
export * from "./m_storyofchina.vue?vue&type=script&lang=js"
import style0 from "./m_storyofchina.vue?vue&type=style&index=0&id=50b75737&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b75737",
  null
  
)

export default component.exports